module.exports = __webpack_public_path__ + "static/Zaratan-83ee94f099756ba0079e401deeef8dfc.jpg";